import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Badge } from "../ui/badge";
import { Eye } from "lucide-react";

export const ImagePreviewDialog = ({ previewImage, onClose }) => {
  const imgSrc = previewImage?.image_url
    || (previewImage?.image_base64 ? `data:image/jpeg;base64,${previewImage.image_base64}` : null);

  return (
    <Dialog open={!!previewImage} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px]" data-testid="image-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Eye className="w-5 h-5" />
            {previewImage?.label}
          </DialogTitle>
          <DialogDescription>{previewImage?.description || "No description"}</DialogDescription>
        </DialogHeader>
        {previewImage && (
          <div className="mt-4">
            {imgSrc ? (
              <img src={imgSrc} alt={previewImage.label} className="w-full rounded-lg border" />
            ) : (
              <div className="h-48 flex items-center justify-center bg-muted rounded-lg text-muted-foreground">No image available</div>
            )}
            <div className="flex items-center justify-between mt-4">
              <Badge variant={previewImage.is_positive_example ? "default" : "destructive"}>
                {previewImage.is_positive_example ? "Positive Example" : "Negative Example"}
              </Badge>
              <span className="text-xs text-muted-foreground">
                Added: {new Date(previewImage.created_at).toLocaleDateString()}
              </span>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
